"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Corresponds to 10 frames at 60 Hz.
function debounce(func, wait) {
    if (wait === void 0) { wait = 166; }
    var timeout;
    function debounced() {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var later = function () {
            func.apply(_this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function () {
        clearTimeout(timeout);
    };
    // @ts-ignore
    return debounced;
}
exports.default = debounce;
//# sourceMappingURL=debounce.js.map